import styled from 'styled-components';
import { ColorScheme } from './colorScheme';

export type TypographyAlign = 'left' | 'center' | 'right';

export const BaseTypography = styled.div<{
  $color?: ColorScheme;
  $align?: TypographyAlign;
}>`
  color: ${(props) => props.$color || ColorScheme.DarkGreen};
  ${(props) => props.$align && `text-align: ${props.$align};`}
`;

const LightFontBase = styled(BaseTypography)`
  -webkit-font-smoothing: subpixel-antialiased;
  -moz-osx-font-smoothing: auto;
`;

export const StyledH1 = styled(BaseTypography)`
  font-family: Campton Extra Bold;
  font-size: 32px;
  line-height: 36px;
  letter-spacing: -0.3px;

  @media (min-width: 1000px) {
    font-size: 60px;
    line-height: 78px;
  }
`;

export const StyledH2 = styled(BaseTypography)`
  font-family: Campton Bold;
  font-size: 30px;
  line-height: 40px;
  letter-spacing: -0.3px;

  @media (min-width: 1440px) {
    font-size: 52px;
    line-height: 60px;
  }
`;

export const StyledH3 = styled(BaseTypography)`
  font-family: Campton Bold;
  font-size: 30px;
  line-height: 36px;
  letter-spacing: -0.3px;

  @media (min-width: 1000px) {
    font-size: 44px;
    line-height: 50px;
  }
`;

export const StyledH4 = styled(BaseTypography)`
  font-family: Campton Bold;
  font-size: 30px;
  line-height: 38px;
  letter-spacing: -0.3px;

  @media (min-width: 1000px) {
    font-size: 38px;
    line-height: 44px;
  }
`;

export const StyledH5 = styled(BaseTypography)`
  font-family: Campton Bold;
  font-size: 26px;
  line-height: 32px;
  letter-spacing: -0.3px;

  @media (min-width: 1000px) {
    font-size: 30px;
    line-height: 36px;
  }
`;

export const StyledH6 = styled(BaseTypography)`
  font-family: Campton Bold;
  font-size: 22px;
  line-height: 26px;
  letter-spacing: -0.3px;

  @media (min-width: 1000px) {
    font-size: 25px;
    line-height: 30px;
  }
`;

export const StyledH7 = styled(BaseTypography)`
  font-family: Campton Semi Bold;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: -0.3px;

  @media (min-width: 1000px) {
    font-size: 22px;
    line-height: 28px;
  }
`;

export const StyledH8 = styled(BaseTypography)`
  font-family: Campton Semi Bold;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: -0.3px;

  @media (min-width: 1000px) {
    font-size: 20px;
    line-height: 24px;
  }
`;

export const StyledH9 = styled(BaseTypography)`
  font-family: Campton Semi Bold;
  font-size: 15px;
  line-height: 16px;
  letter-spacing: -0.3px;

  @media (min-width: 1000px) {
    font-size: 19px;
    line-height: 20px;
  }
`;

// New text style variants
export const StyledManchet = styled(LightFontBase)`
  font-family: Campton Book;
  font-size: 19px;
  letter-spacing: -0.3px;
  line-height: 28px;

  @media (min-width: 1000px) {
    font-size: 22px;
    line-height: 40px;
  }
`;

export const StyledContent = styled(LightFontBase)`
  font-family: Campton Book;
  font-size: 18px;
  letter-spacing: 0;
  line-height: 24px;
`;
export const StyledContentLink = styled(LightFontBase)`
  font-family: Campton Medium;
  font-size: 18px;
  letter-spacing: -0.3px;
  line-height: 18px;
`;

export const StyledContentSmall = styled(LightFontBase)`
  font-family: Campton Book;
  font-size: 15px;
  letter-spacing: -0.2px;
  line-height: 19px;
`;

export const StyledContentSmallLink = styled(LightFontBase)`
  font-family: Campton Medium;
  font-size: 15px;
  letter-spacing: -0.2px;
  line-height: 19px;
`;

export const StyledDate = styled(LightFontBase)`
  font-family: Campton Book;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 20px;
`;

export const StyledLabel = styled(LightFontBase)`
  font-family: Campton Book;
  font-size: 12px;
  line-height: 21px;
  letter-spacing: -0.2%;
`;
export const StyledTableLabel = styled(LightFontBase)`
  font-family: Campton Book;
  font-size: 12px;
  line-height: 19px;
  letter-spacing: -0.2%;
`;
